// console.log('modal js is here');

// const requestBtn = document.getElementById('on-request-btn');
// const requestModal = document.querySelector('.request-modal');
// const closeModal = document.getElementById('close-request-modal');

// requestBtn?.addEventListener('click', () => {
//   requestModal.classList.remove('hideRequestModal');
// });

// closeModal?.addEventListener('click', () => {
//   requestModal.classList.add('hideRequestModal');
// });

// // Optional: close when clicking outside content
// requestModal?.addEventListener('click', (e) => {
//   if (e.target.classList.contains('request-modal-overlay')) {
//     requestModal.classList.add('hideRequestModal');
//   } 
// requestModal.append.' '.before('request-modal-overlay')
//    document.addEventListner'click' , 'function [['.request-modal']].classlist.remove('hideRequestModal')
// if('clicked').then('showModalRequest').show()
// else('dont-show-modal').command().
// loop end
// if (modal.has('.show-modal')) {
      // document.querySelector.add('.hide-other')
// } else {
  // document.querySelector.remove('show-modal')
// }
// });



// console.log('modal js loaded');

document.addEventListener('click', function (e) {

  // OPEN MODAL
  if (e.target.closest('#on-request-btn')) {
    const modal = document.querySelector('.request-modal');
    modal?.classList.remove('hideRequestModal');
  }

  // CLOSE BUTTON
  if (e.target.closest('#close-request-modal')) {
    const modal = document.querySelector('.request-modal');
    modal?.classList.add('hideRequestModal');
  }

  // OVERLAY CLICK
  if (e.target.classList.contains('request-modal-overlay')) {
    const modal = document.querySelector('.request-modal');
    modal?.classList.add('hideRequestModal');
  }

});

